import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	onlyTitleMatch: {
		id: 'search-page.filters.names.titleMatchOnly',
		defaultMessage: 'Search title only',
		description: 'Label for filtering by exact title match',
	},
});
